export default __webpack_public_path__ + "static/media/mia_arana_fibromialgia_en_positivo.51014585.jpg";